import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";
import { theme } from "@huub-web/ui/theme/css/theme.css";
import { zIndexes } from "@huub-web/ui/theme/zIndex";

export const containerStyle = style({
  position: "absolute",
  bottom: theme.spacings.m,
  right: theme.spacings.m,
  zIndex: zIndexes.mapControls,
  maxWidth: rem(320),
  minWidth: rem(280),
  pointerEvents: "auto",
});

export const cardInnerStyle = style({
  padding: theme.spacings.s,
});
